<template>
  <div>
    <sdz-modal
      ref="sdzModalRef"
      @confirm="onConfirm"
      @close="close"
      width="450"
      title="Excluir rateio"
      text="Você realmente deseja excluir este rateio?"
      buttons-position="right"
      confirm-button-label="Excluir"
      confirm-button-background-color="red"
    />
  </div>
</template>

<script>
export default {
  name: 'DeleteApportionmentModal',

  components: {
    SdzModal: () => import('@/components/sdz/SdzModal.vue'),
  },

  methods: {
    open() {
      this.$refs.sdzModalRef.show = true
    },
    close() {
      this.$refs.sdzModalRef.show = false
      this.$emit('cancelDeleteApportionment')
    },
    onConfirm() {
      this.$emit('confirmDeleteApportionment')
    }
  }
}
</script>
